/**
 * Medium and Source Configuration
 * Defines the mapping between Medium and available Sources
 */

export const MEDIUM_OPTIONS = ['Online', 'Offline'];

export const SOURCE_MAPPING = {
  Online: [
    'IndiaMart',
    'Facebook',
    'Instagram',
    'Youtube',
    'Website',
    'Google Ads',
    'LinkedIn',
    'Facebook Ads',
    'Instagram Ads',
    'Youtube Ads',
    'Email',
    'Others'
  ],
  Offline: [
    'TradeFair',
    'Reference',
    'VACSPL Old Customer',
    'My Old Customer',
    'Others'
  ]
};

